import style from "../../assets/scss/sub/partnership.module.scss";
import {FloatingBtn} from "../common/button/FloatingBtn";
import {useFooter, useLanguage} from "../../hooks/hooks";
import {useEffect} from "react";
import {usePartnershipDetailImages} from "../../hooks/usePartnershipDetailImages";

export function Partnership() {
  const { setShowFooter } = useFooter();
  const { detailImages, detailEnImages } = usePartnershipDetailImages();
  const { isKorean } = useLanguage();
  const title = isKorean ? "제휴 문의" : "Partnership Inquiry";
  const images = isKorean ? detailImages : detailEnImages;

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowFooter(true);
    // eslint-disable-next-line
  }, []);

  return (
    <main className={style.partnership}>
      <FloatingBtn />
      <div className={style.title}>
        <h2 className={style.text}>{title}</h2>
      </div>
      <article className={style.article}>
        <div className={style.bgItem1}></div>
        <div className={style.bgItem2}></div>
        <div className={style.bgItem3}></div>
        <section className={style.imageSection}>
          {images.map((detailFile, index) => {
              return <img key={`detail${index}`} src={detailFile.url} alt={"상세 이미지"} />;
          })}
        </section>
      </article>
    </main>
  );
}
